import React, { Component } from "react";
import { MenuItems } from "./MenuItem";
import "./NavBar.css";
import { Redirect } from "react-router-dom";
import {  Link } from "react-router-dom";

class NavBar extends Component {
    constructor(props) {
        super(props);
        this.onLogout = this.onLogout.bind(this);
    }
  state = { clicked: false};

  handleClick = () => {
    this.setState({ clicked: !this.state.clicked });
  };

  onLogout() {
    
}

  render() {
    if (localStorage.getItem("Admin1token") != null)
    {
      return(<Redirect to="/admin"/>)
    }

  

    return (
     
        <nav className="NavBarItems">
         <img width="120px" height="80px" src="logo3.png"/>
         <h1 className="navbar-logo">
            Relocator
          </h1>
          <div className="menu-icon" onClick={this.handleClick}>
            {
              <i
                className={this.state.clicked ? "fa fa-times" : "fa fa-bars"}
              ></i>
            }
            
          </div>
          <ul className={this.state.clicked  ? "nav-menu active" : "nav-menu"}>

       
            {MenuItems.map((item, index) => {
              return (
                <li key={index} onClick={this.handleClick}>
                  <Link className={item.cName} to={item.url}>
                    {item.title}
                  </Link>
                </li>
              );
            })}
          </ul>
         
        </nav>
       
            
      
    );
  }
}

export default NavBar;
